module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/ActionLogContent.ejs -->\n<div class="action-log">\n    <table class="footable table table-striped">\n        <tbody>\n            ';
 if (collection.length === 0) { 
__p+='\n                <tr class="table-no-entries">\n                    <td>\n                        <h2>There are currently no entries</h2>\n                    </td>\n                </tr>\n            ';
 } 
__p+='\n        </tbody>\n    </table>\n\n    ';
 if (collection.length >= limit) { 
__p+='\n        '+
((__t=( showMoreBtn ))==null?'':__t)+
'\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/ActionLogContent.ejs
// module id = 805
// module chunks = 1